var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserTariff',_vm._b({staticClass:"tariff"},'UserTariff',_vm.row.tariffValue,false))}
var staticRenderFns = []

export { render, staticRenderFns }